// extracted by mini-css-extract-plugin
module.exports = {"sticky":"Banner_sticky__P_NAs","banner":"Banner_banner__jid0L"};